/* eslint-disable max-len */
import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useDispatch, useSelector } from 'react-redux';
import { WorkOrderCreators } from '../../views/WorkOrders/store';
// import styledComponents from 'styled-components';
import ButtonComp from '../../component/Common/Button/Button.view';
// eslint-disable-next-line import/named
import { EditorContainer } from './Editor.style';
import { getStringLocale } from '../../constants/language';
const Editor = (props) => {
  const { value: editorHtml, name, onChange: setEditorHtml, width } = props;
  const {
    userData: { profileName, mail }
  } = useSelector((state) => state.loginData);
  const dispatch = useDispatch();
  const save = () => {
    dispatch(
      WorkOrderCreators.addWorkOrderRemarks({
        Email: mail,
        remarks_by: profileName,
        remark: editorHtml
      })
    );
  };

  const clear = () => {
    setEditorHtml('');
  };

  return (
    <>
      <EditorContainer wd={width}>
        <ReactQuill
          // theme={theme}
          onChange={setEditorHtml}
          value={editorHtml}
          modules={Editor.modules}
          formats={Editor.formats}
          placeholder={getStringLocale('Add you your remarks here')}
        />
      </EditorContainer>
    </>
  );
};

Editor.modules = {
  toolbar: [['bold', 'italic', 'underline', 'strike', 'size'], [{ color: [] }]],
  clipboard: {
    matchVisual: false
  }
};

Editor.formats = [
  'header',
  'fonts',
  'size',
  'color',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'html',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'video',
  'code-block',
  'emoji'
];

export default Editor;
